import { PagesModule } from 'pages/pages.module';
import { NgModule } from '@angular/core';
import { ComponentsModule } from 'components/components.module';
import { CoachBrandingPage } from 'pages/coach-branding/coach-branding';

@NgModule({
  declarations: [CoachBrandingPage],
  imports: [PagesModule, ComponentsModule],
  exports: [CoachBrandingPage],
})
export class CoachBrandingPageModule {}
